import React from 'react';
import { Icon } from '../icon/Icon.jsx';

/* The most safety-relevant micro-interaction in the UI. Dimming the VALUE rather
   than only flagging the chip is the point: stale data displayed as if fresh is
   the most dangerous defect this UI can have, and a badge alone is too easy to
   read past. Pair with <Num stale /> whenever state is "stale". */

export function AgeChip({ age, state = 'fresh', style }) {
  const attn = state !== 'fresh';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: 'var(--caption-size)', lineHeight: 'var(--caption-line)',
      color: attn ? 'var(--attn)' : 'var(--text-tertiary)',
      fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', ...style,
    }}>
      {state === 'stale' ? <Icon name="triangle-alert" size={11} /> : null}
      {age}
    </span>
  );
}
